/* eslint-disable import/prefer-default-export */
export const GET_STANDING = 'GET_STANDING'
